import { addNavMenuItem } from '@vendure/admin-ui/core';

export default [
    addNavMenuItem(
        {
            id: 'survey',
            label: 'Satisfação',
            routerLink: ['/extensions/survey'],
            icon: 'feedback',
        },
        'marketing'
    ),
];
